<template>
  <div>
    <KTCodePreview v-bind:title="'Báo cáo tổng hợp'">
      <template v-slot:preview>
        <!-- Header session -->
        <b-form @submit.prevent="fetchData()">
          <b-row class="mb-5">
            <b-col md="3">
              <div class="d-flex justify-content-center align-items-center">
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="dpForm.startDate"
                ></date-picker>
                <span class="mx-2">-</span>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="dpForm.endDate"
                ></date-picker>
              </div>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <b-form-select
                  size="sm"
                  v-model="selectedDepartmentId"
                  :options="listDepartment"
                  value-field="id"
                  text-field="name"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"
                      >-- Chọn bộ phận --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="checkPermission('CR_VIEW_ALL')">
              <b-button
                type="submit"
                variant="primary"
                size="sm"
                style="fontweight: 600; width: 70px"
                :disabled="onLoading"
                @click="fetchData()"
                >Lọc</b-button
              >
            </b-col>
            <b-col md="2" class="ml-auto">
              <b-dropdown
                size="sm"
                id="dropdown-1"
                right
                v-if="checkPermission('CR_EXPORT_ALL')"
              >
                <template slot="button-content">
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  <span class="font-weight-bolder">Xuất dữ liệu</span>
                </template>
                <b-dropdown-item
                  @click="reportClick(1)"
                  v-if="checkPermission('CR_EXPORT_ALL')"
                >
                  <span>
                    <i style="font-size: 1rem" class="far fa-file-excel"></i>
                    &nbsp; Xuất báo cáo tổng hợp</span
                  >
                </b-dropdown-item>
                <b-dropdown-item
                  @click="reportClick(2)"
                  v-if="checkPermission('CR_EXPORT_ALL')"
                >
                  <span>
                    <i style="font-size: 1rem" class="far fa-file-excel"></i>
                    &nbsp; Xuất báo cáo chi tiết</span
                  >
                </b-dropdown-item>
                <b-dropdown-item
                  @click="reportClick(3)"
                  v-if="checkPermission('CR_EXPORT_ALL')"
                >
                  <span>
                    <i style="font-size: 1rem" class="far fa-file-excel"></i>
                    &nbsp; Danh sách hóa đơn</span
                  >
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>
        </b-form>

        <!-- End of Header session -->
        <!-- Table session -->
        <b-table
          :items="listItem"
          :fields="fields"
          hover
          bordered
          show-empty
          :empty-text="tableEmptyText"
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
          </template>

          <template v-slot:cell(count)="row">
            <div style="text-align: center">
              <span v-text="row.item.count" class="text-right"></span>
            </div>
          </template>
          <template v-slot:cell(totalPoint)="row">
            <div style="text-align: right">
              <span
                v-text="formatPrice(row.item.totalPoint)"
                class="text-right"
              ></span>
            </div>
          </template>
          <template v-slot:cell(addPoint)="row">
            <div style="text-align: right">
              <div
                class="productCode text-primary"
                @click="linkToDetail(row.item)"
                style="cursor: pointer"
              >
                <span
                  v-text="formatPrice(row.item.addPoint)"
                  class="text-right"
                ></span>
              </div>
            </div>
          </template>
          <template v-slot:cell(subtractPoint)="row">
            <div style="text-align: right">
              <div
                class="productCode text-warning"
                @click="linkToDetail(row.item)"
                style="cursor: pointer"
              >
                <span
                  v-text="formatPrice(row.item.subtractPoint)"
                  class="text-right"
                ></span>
              </div>
            </div>
          </template>
          <template v-slot:cell(finalPoint)="row">
            <div style="text-align: right">
              <span
                v-text="formatPrice(row.item.finalPoint)"
                class="text-right"
              ></span>
            </div>
          </template>
        </b-table>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { BASE_URL } from '@/utils/constants';
import { vi } from 'vuejs-datepicker/dist/locale';
import { VclTable } from 'vue-content-loading';
import datePicker from 'vue-bootstrap-datetimepicker';

import axios from 'axios';
import fileDownload from '@/utils/file-download';
import { makeToastFaile, formatPrice, handleError } from '@/utils/common';
import apiCommonMixin from '@/view/mixins/api-common.mixins';
import permissionMixin from '@/view/mixins/permission.mixin';
import {
  DP_CONFIG,
  formatDBDate,
  getStartOfMonth,
  getEndOfMonth,
} from '@/utils/date';

export default {
  mixins: [apiCommonMixin, permissionMixin],
  data() {
    return {
      dpForm: {
        startDate: getStartOfMonth(),
        endDate: getEndOfMonth(),
      },
      dpConfigs: DP_CONFIG,
      onLoading: false,
      disabledDates: {},
      format: 'dd-MM-yyyy',
      language: vi,
      searchFromDay: '',
      searchToDay: '',
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '5%',
          },
          tdClass: 'sttClass',
        },
        {
          key: 'code',
          label: 'Mã NV',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
        },
        {
          key: 'fullName',
          label: 'Tên nhân viên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'jobTitleName',
          label: 'Chức vụ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'departmentName',
          label: 'Bộ phận',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'totalPoint',
          label: 'Điểm thưởng',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'addPoint',
          label: 'Cộng khác',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'subtractPoint',
          label: 'Trừ khác',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'finalPoint',
          label: 'Tổng thưởng',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
      ],
      listItem: [],
      listDepartment: [],
      selectedDepartmentId: null,
      hasSearched: false,
    };
  },
  computed: {
    tableEmptyText() {
      if (!this.hasSearched) {
        return 'Vui lòng chọn bộ phận và bấm Lọc để xem báo cáo';
      }
      return 'Không có nhân sự thuộc bộ phận đang tìm kiếm';
    },
  },
  methods: {
    formatPrice,
    reportClick: async function (mode) {
      const searchFromDay = formatDBDate(this.dpForm.startDate);
      const searchToDay = formatDBDate(this.dpForm.endDate);

      if (!searchFromDay) {
        makeToastFaile('Bạn chưa chọn ngày bắt đầu!');
        return;
      }
      if (!searchToDay) {
        makeToastFaile('Bạn chưa chọn ngày kết thúc!');
        return;
      }

      let route = '';
      switch (mode) {
        case 1:
          route = 'export-report';
          break;
        case 2:
          route = 'export-excel-detail';
          break;
        case 3:
          route = 'export-list-bill';
          break;
      }

      const urlSearchParams = new URLSearchParams({
        fromDate: searchFromDay,
        toDate: searchToDay,
        departmentId: this.selectedDepartmentId,
      }).toString();
      const url = `${BASE_URL}v1/reward-cr-reports/${route}?${urlSearchParams}`;
      await axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      })
        .then((response) => {
          const fileName = fileDownload.getFileName(response);
          fileDownload.createFile(response.data, fileName);
        })
        .catch(() => {
          console.log('Xảy ra lỗi khi xuất dữ liệu');
        });
    },
    fetchData: async function () {
      if (this.onLoading) return;

      const searchFromDay = formatDBDate(this.dpForm.startDate);
      const searchToDay = formatDBDate(this.dpForm.endDate);
      if (!this.selectedDepartmentId) {
        return makeToastFaile('Vui lòng chọn bộ phận xem báo cáo!');
      }
      this.hasSearched = true;
      const params = {
        fromDate: searchFromDay,
        toDate: searchToDay,
        departmentId: this.selectedDepartmentId,
      };
      this.onLoading = true;
      try {
        const response = await ApiService.query(`v1/reward-cr-reports`, {
          params,
        });
        this.listItem = response.data.data.data.map((item, index) => {
          return {
            count: index + 1,
            ...item,
          };
        });
      } catch (error) {
        handleError(error);
      } finally {
        this.onLoading = false;
      }
    },
    linkToDetail: function (item) {
      const searchFromDay = this.dpForm.startDate;
      const searchToDay = this.dpForm.endDate;
      const { href } = this.$router.resolve({
        name: 'reward-detail',
        query: {
          fromDate: searchFromDay,
          toDate: searchToDay,
          employeeId: item.id,
          employeeName: item.fullName,
        },
      });
      window.open(href, '_blank');
    },
    setDepartmentOptions: async function () {
      const departments = await this.fetchDepartments();
      this.listDepartment = departments;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Báo cáo hoa hồng tổng hợp', route: 'overview' },
      { title: 'Danh sách báo cáo hoa hồng tổng hợp' },
    ]);
    this.setDepartmentOptions();
  },
  created() {},
  components: {
    KTCodePreview,
    VclTable,
    datePicker,
  },
};
</script>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.5em;
}

.example {
  border: 1px solid #ddd;
  margin-bottom: 2em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #ddd;
  border-radius: 3px;
}

.settings {
  margin: 2em 0;
  border-top: 1px solid #bbb;
  background: #eee;
}

/* h5 {
  font-size: 100%;
  padding: 0;
} */

.form-group {
  margin-bottom: 1em;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.sttClass {
  width: 20px;
}
.productCode:hover {
  text-decoration: underline;
}
</style>
